/* eslint-disable import/no-duplicates */
import { createContext, ReactNode, useReducer } from 'react';
import { getApps, initializeApp } from 'firebase/app';
// @types
import { ActionMap, AuthState, AuthUser, FirebaseContextType } from '../@types/authentication';
import { firebaseConfig } from 'config';
// import { getAuth } from 'firebase/auth';
//

// ----------------------------------------------------------------------

const ADMIN_EMAILS = ['demo@minimals.cc'];
if (!getApps().length) {
  initializeApp(firebaseConfig);
}
const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

enum Types {
  Initial = 'INITIALISE'
}

type FirebaseAuthPayload = {
  [Types.Initial]: {
    isAuthenticated: boolean;
    user: AuthUser;
  };
};

type FirebaseActions = ActionMap<FirebaseAuthPayload>[keyof ActionMap<FirebaseAuthPayload>];

const reducer = (state: AuthState, action: FirebaseActions) => {
  if (action.type === 'INITIALISE') {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  }

  return state;
};

const AuthContext = createContext<FirebaseContextType | null>(null);

function AuthProvider({ children }: { children: ReactNode }) {
  // const [profile, setProfile] = useState<.DocumentData | undefined>();
  const [state, dispatch] = useReducer(reducer, initialState);

  // useEffect(
  //   () =>
  //     getAuth().onAuthStateChanged((user) => {
  //       if (user) {
  //         const docRef = firebase.firestore().collection('users').doc(user.uid);
  //         docRef
  //           .get()
  //           .then((doc) => {
  //             if (doc.exists) {
  //               setProfile(doc.data());
  //             }
  //           })
  //           .catch((error) => {
  //             console.error(error);
  //           });

  //         dispatch({
  //           type: Types.Initial,
  //           payload: { isAuthenticated: true, user }
  //         });
  //       } else {
  //         dispatch({
  //           type: Types.Initial,
  //           payload: { isAuthenticated: false, user: null }
  //         });
  //       }
  //     }),
  //   [dispatch]
  // );

  // const login = (email: string, password: string) =>
  //   getAuth().signInWithEmailAndPassword(email, password);

  // const loginWithGoogle = () => {
  //   const provider = new firebase.auth.GoogleAuthProvider();
  //   provider.addScope('https://www.googleapis.com/auth/photoslibrary.readonly');
  //   provider.addScope('https://www.googleapis.com/auth/photoslibrary');
  //   return getAuth().signInWithPopup(provider);
  // };

  // const loginWithFaceBook = () => {
  //   const provider =  getAuth().FacebookAuthProvider();
  //   return getAuth().signInWithPopup(provider);
  // };

  // const loginWithTwitter = () => {
  //   const provider = new firebase.auth.TwitterAuthProvider();
  //   return firebase.auth().signInWithPopup(provider);
  // };

  // const register = (email: string, password: string, firstName: string, lastName: string) =>
  //   firebase
  //     .auth()
  //     .createUserWithEmailAndPassword(email, password)
  //     .then((res) => {
  //       firebase
  //         .firestore()
  //         .collection('users')
  //         .doc(res.user?.uid)
  //         .set({
  //           uid: res.user?.uid,
  //           email,
  //           displayName: `${firstName} ${lastName}`
  //         });
  //     });

  // const logout = async () => {
  //   await firebase.auth().signOut();
  // };

  // const resetPassword = async (email: string) => {
  //   await firebase.auth().sendPasswordResetEmail(email);
  // };

  const auth: Partial<AuthUser> = { ...state.user };

  // <AuthContext.Provider
  //   value={{
  //     ...state,
  //     method: 'firebase',
  //     user: {
  //       id: auth.uid,
  //       email: auth.email,
  //       photoURL: auth.photoURL || profile?.photoURL,
  //       displayName: auth.displayName || profile?.displayName,
  //       role: ADMIN_EMAILS.includes(auth.email) ? 'admin' : 'user',
  //       phoneNumber: auth.phoneNumber || profile?.phoneNumber || '',
  //       country: profile?.country || '',
  //       address: profile?.address || '',
  //       state: profile?.state || '',
  //       city: profile?.city || '',
  //       zipCode: profile?.zipCode || '',
  //       about: profile?.about || '',
  //       isPublic: profile?.isPublic || false
  //     },
  //     // login,
  //     // register,
  //     // loginWithGoogle,
  //     // loginWithFaceBook,
  //     // loginWithTwitter,
  //     // logout,
  //     // resetPassword,
  //     updateProfile: () => {}
  //   }}
  // >
  //   {children}
  // </AuthContext.Provider>
}

export { AuthContext, AuthProvider };
